import { container, title } from "assets/jss/material-kit-react.jsx";

const clipPageStyle = {
  container: {
    zIndex: "12",
    color: "#FFFFFF",
    marginTop: "80px",
    padding: "20px",
    ...container
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    color: "black",
    textDecoration: "none"
  },
  section: {
    padding: "30px 0",
    textAlign: "center",
    color: "black"
  },
  main: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3"
  },
  mainRaised: {
    margin: "0px 30px 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  },
  itemTitle:{
    textDecoration: "underline"
  },
  block:{
    display: "block"
  }
};

export default clipPageStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/clipPage.jsx